// const SERVER_URL = "http://localhost:8080/"
const SERVER_URL =
  "https://joy-of-others-backend-nodejs-2mk6mheziq-uc.a.run.app/";
const IMAGE_URL = "https://storage.googleapis.com/cdn-be-positive-u/";
module.exports = {
  SERVER_URL,
  IMAGE_URL,
};
